
import "./components/transition.js";
//import "./components/search.js"
import "./components/dropdown.js";
import "./semantic-dropdown.scss";

import { ISelectOption } from '@/apps/car-details/types';

type dropdownCallback = (this: JQuery, value: any, text: string, $choice: JQuery) => void;
//type searchCallback = (this:JQuery, searchTerm:string) => boolean | void ;

export const StandardSearchDropdownOptions: any = {
    placeholder: false,
    allowAdditions: false,
    forceSelection: false,
    fullTextSearch: "exact",    
    ignoreCase: true,
    ignoreSearchCase: true,
    className: { menu: 'scrollhint menu' },
    match: "text",
  //  debug: true,
  //  verbose: true,
};

const searchAddDropdown: any = {
    allowAdditions: true,
    match: "text",
    fullTextSearch: false,
    ignoreCase: true,
    ignoreSearchCase: true,
    className: { menu: 'scrollhint menu' },
};


const searchAddClearableDropdown: any = {
    allowAdditions: true,
    match: "text",
    fullTextSearch: false,
    ignoreCase: true,
    ignoreSearchCase: true,
    className: { menu: 'scrollhint menu' },
    placeholder:false,
    clearable:true
};




const keyedOptions: { [name: string]: SemanticUI.DropdownSettings } = {
    'default': StandardSearchDropdownOptions,
    'search-add': searchAddDropdown,
    'search-add-clearable': searchAddClearableDropdown,
    'dealer-select': {
        fullTextSearch: "exact", 
        forceSelection:true,
        match: "text",
    }
};


export class SemanticDropdown {

    ctl:JQuery<HTMLElement>;
    
    constructor(el: string|HTMLElement, settings: SemanticUI.DropdownSettings | undefined = undefined) {
    
        this.ctl = (typeof el == 'string') ? $(el) : $(el);

        if (settings) this.ctl.suidropdown(settings);
        
        console.log("[semantic-dropdown] initialized", this.ctl.attr('id'));
    }

    clearAll() { 
        this.clear();
        this.setOptions([{name:"", value:""}]);
    }
    
    clear() { this.ctl.suidropdown('clear'); }
    refresh() { this.ctl.suidropdown('refresh'); }
    
    show(/*cb?:()=>void|undefined, preventFocus?:boolean|undefined*/) { this.ctl.suidropdown('show');}

    //@ts-ignore
    setOptions(values: ISelectOption[]) { this.ctl.suidropdown('setup menu', { values }); }

    //@ts-ignore
    setValues(values: ISelectOption[]) { this.ctl.suidropdown('change values', { values }); }

    updateOptions(options: ISelectOption[]){
        
       // Update the hidden select control
        this.ctl.empty();   
        
        options.forEach((value)=>
        {
            this.ctl.append($("<option></option>").attr("value", value.value).text(value.name));
        });

        // Update the semantic dropdown
        this.setOptions(options);               
    }

    smartUpdateOptions(options: ISelectOption[]) {
        
        const oldValue = this.getValue();

        this.updateOptions(options);

        var match = options.find(x => x.value === oldValue);

        if (match){
            this.select(match.value);
        }
        else this.clear();
        
    }

    select(value:any) { 
        if (value)
        this.ctl.suidropdown('set selected', value);
        else
        this.clear();
    }

    deselect(value: any) {
        this.ctl.suidropdown('remove selected', value);
    }

    toggleSelect(value:any):boolean {

        const selection = this.getValue();
        
        const selected = Array.isArray(selection) ?
            selection.includes(value) : 
            selection == value;

        if (selected){
            this.deselect(value);
            return false;
        }
        else
        {
            this.select(value);
            return true;
        }      
    }

    getValue() { return this.ctl.suidropdown('get value'); }


    getText() { return this.ctl.suidropdown('get text'); }
    setText(text:string) { this.ctl.suidropdown('set text', text); }
    getInitialText() { return this.ctl.suidropdown('get default text'); }

    onChange(cb: dropdownCallback){this.ctl.suidropdown('setting', 'onChange',cb);}

    onAdd(cb: dropdownCallback) { this.ctl.suidropdown('setting', 'onAdd', cb); }
    onRemove(cb: dropdownCallback) { this.ctl.suidropdown('setting', 'onRemove', cb); }
    
    //onSearch(cb: searchCallback) { this.ctl.suidropdown('setting', 'onSearch', cb); }

    saveDefaults() { this.ctl.suidropdown('save defaults') };

    restoreDefaults(){ this.ctl.suidropdown('restore defaults');}

    restoreDefaultText() { this.ctl.suidropdown('restore default text'); }
    restoreDefaultValue() { this.ctl.suidropdown('restore default value'); }

    allowAdditions(hide:boolean = true){
        this.ctl.suidropdown('setting', 'allowAdditions', true);
        this.ctl.suidropdown('setting', 'hideAdditions', hide);
    }  

    forceSelection(force:boolean) {
        this.ctl.suidropdown('setting', 'forceSelection', force);        
    }  

    fullTextSearch(fulltext: boolean|"exact") {
        this.ctl.suidropdown('setting', 'fullTextSearch', fulltext);
    }  
}

export function initializeDropdowns(selector: string, optionsKey?: string):JQuery {
    const ctl: JQuery<HTMLElement> = $(selector);
    const options = keyedOptions[optionsKey ?? "default"];
    console.log(`Initialized ${ctl.length} dropdowns with ${optionsKey}`);
    return ctl.suidropdown(options);
}

export function initializeDropdown(el: string | HTMLElement, optionsKey?:string|null):JQuery {
    const ctl:JQuery<HTMLElement> = (typeof el == 'string') ? $(el) : $(el);
    const options = keyedOptions[optionsKey ?? "default"];
    console.log(`Initialized 1 dropdowns with ${optionsKey}`);
    return ctl.suidropdown(options);
}
